/**
 * BIN Block List — Organized by Country
 * 
 * Each key is a country name (case-sensitive).
 * Each value is an array of 6-digit BIN prefixes (strings) to block.
 * 
 * These BINs typically belong to virtual, prepaid, or non-physical cards
 * that should be rejected at the frontend before form submission.
 */

export const BIN_BLOCK_LIST = {

  // ─── Philippines ──────────────────────────────────────────────
  Philippines: [
    "454647", "454648", "454649",
    "524772", "524773", "524774",
    "431940", "431941", "431942",
    "553174", "553175", "553176",
    "400608", "400609", "400610",
  ],

  // ─── Qatar & Middle East ─────────────────────────────────────
  Qatar: [
    "403024", "403025", "403026",
    "510040", "510041", "510042",
    "458900", "458901", "458902",
    "542418", "542419", "542420",
  ],

  // ─── Austria ──────────────────────────────────────────────────
  Austria: [
    "464647", "464648", "464649",
    "516780", "516781", "516782",
    "426397", "426398", "426399",
    "530125", "530126", "530127",
  ],

  // ─── United Kingdom ───────────────────────────────────────────
  UK: [
    "475129", "475130", "475131",
    "537210", "537211", "537212",
    "428500", "428501", "428502",
  ],

  // ─── Germany ──────────────────────────────────────────────────
  Germany: [
    "410162", "410163", "410164",
    "520356", "520357", "520358",
  ],

  // ─── UAE ──────────────────────────────────────────────────────
  UAE: [
    "458900", "458901", "458902",
    "542418", "542419", "542420",
  ],

  // ─── Kuwait ───────────────────────────────────────────────────
  Kuwait: [
    "403024", "403025", "403026",
    "510040", "510041", "510042",
  ],

};
